import { HiBriefcase } from "react-icons/hi2";

export const AddExperienceIcon = ({ width, height, color, ...props }) => (
  <HiBriefcase
    size={width || height || 11}
    color={color || "currentColor"}
    {...props}
  />
);
